import { useState, useEffect } from 'react';
import { FetchRequestTypes, useFetch } from '../../../hooks/useFetch';
import { HistoryData, HistoryDataItem, SelectedShip } from '../interfaces/arrivalsDepartures.interfaces';
import dayjs from 'dayjs';

export interface ShipVisitHistoryData {
  imoNumber: string | null;
  loadMore: boolean;
  dateSpan: Date[] | undefined;
}

export const useShipVisitHistoryData = ({ imoNumber, loadMore, dateSpan }: ShipVisitHistoryData) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [historyData, setHistoryData] = useState<HistoryData | null>(null);
  const [historyList, setHistoryList] = useState<HistoryDataItem[] | null>(null);
  const [noMoreToLoad, setNoMoreToLoad] = useState(false);
  const itemsToLoad = 20;

  const { data, loading, error } = useFetch(dataUrl, FetchRequestTypes.GET);

  useEffect(() => {
    if (imoNumber) {
      setHistoryList(null);
      setHistoryData(null);
      setNoMoreToLoad(false);

      const from = (dateSpan && dayjs(dateSpan[0]).toISOString()) || '';
      const to = (dateSpan && dayjs(dateSpan[1]).toISOString()) || '';

      setDataUrl(`/api-aad/web-backend/v1/visit?imo=${imoNumber}&from=${from}&to=${to}&count=${itemsToLoad}`);
    }
  }, [imoNumber, dateSpan]);

  useEffect(() => {
    if (loadMore && !noMoreToLoad) {
      const continuationToken = (historyData as HistoryData)?.continuationToken || '';
      setDataUrl(
        `/api-aad/web-backend/v1/visit?imo=${imoNumber}&count=${itemsToLoad}&continuationToken=${continuationToken}`
      );
    }
  }, [loadMore]);

  useEffect(() => {
    if (data) {
      //Filter data to show only ships with both arrival and departure times
      const filteredData = (data.items as HistoryDataItem[]).filter((item) => item.arrivalTime && item.departureTime);

      setHistoryData(data);
      if (historyList) {
        setHistoryList([...historyList, ...filteredData]);
      } else {
        setHistoryList([...filteredData]);
      }
      setDataUrl(null);

      if (!data.continuationToken) {
        setNoMoreToLoad(true);
      }
    }
  }, [data]);

  useEffect(() => {}, [loading, error]);

  return { historyList, noMoreToLoad, loading, error };
};

